import React, { memo } from 'react';

export default memo(props => {
  return (
    <div>
      <i className="icon-info22" />
    </div>
  );
});
